import axios from "axios";
import { apiAddress } from "../../config/server";
import * as types from "./actionTypes";
import { getSelf } from "./personActions";

function beginLogin() {
  return { type: types.BEGIN_LOGIN };
}

function loginRejected(error: any) {
  return { type: types.LOGIN_REJECTED, payload: error };
}

function loginFulfilled(payload: any) {
  return { type: types.LOGIN_FULFILLED, payload };
}

function logoutFulfilled() {
  return { type: types.AUTH_LOGOUT_FULFILLED };
}

function logoutRejected(err: any) {
  return {
    type: types.AUTH_LOGOUT_REJECTED,
    message: err.message,
    stack: err.stack,
  };
}

function logoutStarted() {
  return { type: types.AUTH_LOGOUT_STARTED };
}

export function notAuthenticated() {
  return { type: types.NOT_AUTHENTICATED };
}

export function login(username: string, password: string, remember: boolean) {
  return (dispatch: any) => {
    dispatch(beginLogin());
    return axios
      .post(`${apiAddress}/api/auth`, { username, password, remember })
      .then((response) => {
        if (response.data && response.data.success) {
          dispatch(loginFulfilled(response.data));
          getSelf()(dispatch);
          return response.data;
        }
        throw new Error(
          response.data
            ? response.data.message
            : "An error occurred during sign in, please try again",
        );
      })
      .catch((error) => {
        const message = error.response.data?.message || error.message;
        dispatch(loginRejected(message));
        error.message = message;
        throw error;
      });
  };
}

export function logout() {
  return (dispatch: any) => {
    dispatch(logoutStarted());
    return axios
      .get(`${apiAddress}/logout`)
      .then((response) => {
        dispatch(logoutFulfilled());
        return response;
      })
      .catch((err) => {
        dispatch(logoutRejected(err));
        throw err;
      });
  };
}
